import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-review-url',
  templateUrl: './review-url.component.html',
  styleUrls: ['./review-url.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewUrlComponent {
  @Input() cardHeader: string;
  @Input() reviewPageUrl: string;
  @Input() description: string;
  @Input() hintText: string;

  constructor(
    private snackbarService: SnackbarService,
    private translateService: TranslateService,
  ) {}

  reviewPageURLCopied(success: boolean): void {
    if (success) {
      this.snackbarService.successSnack(this.translateService.instant('COPY_TEXT_MESSAGE.URL'));
    } else {
      this.snackbarService.errorSnack(this.translateService.instant('COPY_TEXT_MESSAGE.FAILED_TO_COPY'));
    }
  }
}
